export default __webpack_public_path__ + "static/media/CR1.f312665b.png";